import { isValidElement } from "react";
import { isPlainObject } from "../../utils/index.js";
function isValidActionBarItem(value) {
  if (!isValidElement(value)) return false;
  const item = value.props;
  if (!isPlainObject(item)) return false;
  if (!Object.hasOwn(item, "icon")) return false;
  if (!Object.hasOwn(item, "label")) return false;
  const { icon, label } = item;
  let _internal;
  if (Object.hasOwn(item, "_internal")) {
    if (!isValidInternal(item._internal)) return false;
    _internal = item._internal;
  }
  let mode;
  if (Object.hasOwn(item, "mode")) {
    if (typeof item.mode !== "string") return false;
    mode = item.mode;
  }
  let disabled;
  if (Object.hasOwn(item, "disabled")) {
    if (typeof item.disabled !== "boolean") return false;
    disabled = item.disabled;
  }
  let onClick;
  if (Object.hasOwn(item, "onClick")) {
    if (typeof item.onClick !== "function") return false;
    onClick = item.onClick;
  }
  let color;
  if (Object.hasOwn(item, "color")) {
    if (typeof item.color !== "string") return false;
    color = item.color;
  }
  let id;
  if (Object.hasOwn(item, "id")) {
    if (typeof item.id !== "string") return false;
    id = item.id;
  }
  let disableInteraction;
  if (Object.hasOwn(item, "disableInteraction")) {
    if (typeof item.disableInteraction !== "boolean") return false;
    disableInteraction = item.disableInteraction;
  }
  let testId;
  if (Object.hasOwn(item, "testId")) {
    if (typeof item.testId !== "string") return false;
    testId = item.testId;
  }
  let className;
  if (Object.hasOwn(item, "className")) {
    if (typeof item.className !== "string") return false;
    className = item.className;
  }
  let tooltip;
  if (Object.hasOwn(item, "tooltip")) {
    tooltip = item.tooltip;
  }
  let sx;
  if (Object.hasOwn(item, "sx")) {
    if (typeof item.sx !== "object") return false;
    sx = item.sx;
  }
  let divider;
  if (Object.hasOwn(item, "divider")) {
    if (typeof item.divider !== "boolean") return false;
    divider = item.divider;
  }
  const obj = {
    _internal,
    className,
    color,
    disabled,
    disableInteraction,
    divider,
    icon,
    id,
    label,
    mode,
    onClick,
    sx,
    testId,
    tooltip
  };
  const isValid = obj;
  return !!isValid;
}
function isValidInternal(value) {
  if (!isPlainObject(value)) return false;
  if (!Object.hasOwn(value, "size")) return false;
  if (!Object.hasOwn(value, "menuMode")) return false;
  if (!Object.hasOwn(value, "parentOnClick")) return false;
  if (!Object.hasOwn(value, "renderInTruncateList")) return false;
  if (!Object.hasOwn(value, "gap")) return false;
  const item = value;
  const { menuMode, parentOnClick, size, gap, renderInTruncateList } = item;
  const obj = { gap, menuMode, parentOnClick, renderInTruncateList, size };
  const isValid = obj;
  const noNewOptionalProps = {};
  return !!isValid && !!noNewOptionalProps;
}
export {
  isValidActionBarItem
};
//# sourceMappingURL=guards.js.map
